import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NoteIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M4 7H20V9H4V7Z' fill='currentColor' />
            <Path d='M4 11H20V13H4V11Z' fill='currentColor' />
            <Path d='M4 15H12V17H4V15Z' fill='currentColor' />
        </>
    ),
})

NoteIcon.displayName = 'NoteIcon'
